import { ButtonStyle, ControlSize, FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../../base/hooks";
import { useEffect, useState } from "react";

import { IReloadButtonProps } from "./IReloadButtonProps";

export const ReloadButtonProperties = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
    { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
]

export const useReloadButtonProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IReloadButtonProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Label })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const label = bindings.getValue<string>(Property.Label)
        const title = bindings.getValue<string>(Property.Tooltip)
        const icon = bindings.getValue<string>(Property.MaterialIcon)
        const disabled = bindings.getValue<boolean>(Property.Disabled)

        const buttonStyle = bindings.getValue<ButtonStyle>(Property.BackgroundStyle)
        const buttonSize = bindings.getValue<ControlSize>(Property.Size)
        const submit = bindings.getValue<boolean>(Property.Submit)
        const type = submit ? "submit" : "button"

        setProperties({ label, type, title, icon, disabled, buttonStyle, buttonSize })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
